import React from 'react';
import { FormattedMessage } from 'react-intl';

import headerActions from './../../reusable/Header/Header.actions';
import editActions from '../../api/EditThirdParty.api';

import Spinnable from './../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper.jsx';

import PreviousPageLink from './../../reusable/PreviousPageLink/PreviousPageLink.jsx';
import AboutEntityPanel from './components/AboutEntityPanel';
import PreviewCompany from './../PreviewCompany/PreviewCompany.index.jsx';
import xhr from './../../utils/xhr';
import reduxStore from './../../reduxStore';
import utils from '../../utils/utilities.js';
import { hashHistory } from 'react-router';

class EditThirdParty extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAboutSectionOpened: true,
            isSearchSectionOpened: true,
            togglePanelPositionUpdate: false,
            toggleDialogPositionUpdate: false
        };

        this.toggleAboutSection = this.toggleAboutSection.bind(this);
        this.toggleSearchParametersSection = this.toggleSearchParametersSection.bind(this);
        this.backLink = this.backLink.bind(this)
    }

    componentWillMount() {
        this.props.spinner.showSpinner();
        
        // Reset company data in case the user navigates away and edits another entity
        reduxStore.dispatch({type: 'LOAD_COMPANY_DATA', payload: null});

        editActions.loadCompanyData(this.props.params.companyId)
            .then((companyData)=>{
                reduxStore.dispatch({type: 'LOAD_COMPANY_DATA', payload:companyData});

                // The Edit panel position needs to be updated here because only when the company data is loaded, all
                // DOM elements in the About section are rendered. Thus, the panel position is calculated correctly only
                // when all the about section elements are rendered on the page.
                this.setState({ togglePanelPositionUpdate: !this.state.togglePanelPositionUpdate });

                this.props.spinner.hideSpinner();
            })
            .catch((error)=>{
                xhr.handleAllErrors(error);
                this.props.spinner.hideSpinner();
            });
    }

    componentDidMount() {
        headerActions.updateHeader('editThirdParty');
    }

    toggleAboutSection() {
        this.setState({
            isAboutSectionOpened: !this.state.isAboutSectionOpened,
            togglePanelPositionUpdate: !this.state.togglePanelPositionUpdate
        });
    }

    toggleSearchParametersSection() {
        this.setState(... this.state, {
            isSearchSectionOpened: !this.state.isSearchSectionOpened,
            togglePanelPositionUpdate: !this.state.togglePanelPositionUpdate
        });
    }

    backLink() {
        let backLink;
        switch (utils.getQueryParam('backRoute')) {
            case "entity-dashboard":
                backLink = "/entity-dashboard/" + this.props.params.companyId;
                break;
            default:
                backLink = "/manage-third-parties";
        }

        return backLink;
    }

    returnToManageEntitiesPage() {
        hashHistory.push('/manage-third-parties');
    }

    render() {
        return (
            <div className="edit-third-party">
                <div className="top-navigation">
                    <PreviousPageLink
                        location={this.backLink()}
                        text="General_CoreFunctionality_UIText_general.backToPreviousPage" />
                    <button className="button-secondary-lg cancel" type="button" onClick={this.returnToManageEntitiesPage}>
                        <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel" />
                    </button>
                </div>

                <div className="edit-third-party__about">
                    <a className="edit-third-party__open-section-link" onClick={this.toggleAboutSection}>
                        <span className={this.state.isAboutSectionOpened ? 'la-TriangleDown' : 'la-TriangleRight'}>
                        </span>
                        <h2><FormattedMessage id="Entities_Edit_UIText_editThirdParty.aboutSectionTitle" /></h2>
                    </a>

                    <div className={this.state.isAboutSectionOpened ? '' : ' hidden'}>
                        <AboutEntityPanel parent={this} name="about panel"/>
                    </div>

                </div>
                <div className="edit-third-party__search-parameters">
                    <a className="edit-third-party__open-section-link" onClick={this.toggleSearchParametersSection}>
                        <span className={this.state.isSearchSectionOpened ? 'la-TriangleDown' : 'la-TriangleRight'}>
                        </span>
                        <h2><FormattedMessage id="Entities_Edit_UIText_editThirdParty.searchSectionTitle" /></h2>
                    </a>

                    <div className={this.state.isSearchSectionOpened ? '' : ' hidden'}>

                        <PreviewCompany isEmbeddedComponent
                                        isSearchSectionOpened={this.state.isSearchSectionOpened}
                                        togglePanelPositionUpdate={this.state.togglePanelPositionUpdate}
                                        params={{companyId: this.props.params.companyId}} />
                    </div>
                </div>
            </div>
        );

    }

}

export default Spinnable(EditThirdParty);


// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/EditThirdParty.jsx